import jwt from "../../auth"
import router from '../../router'
import axios from "../../axios";
import {synchronizer} from '../../utils/synchronizer'
import {api} from "../../utils/api";
import store from "../store";
//import Echo from "laravel-echo"

export default {

    // JWT
    login({ commit }, payload) {

        return new Promise((resolve,reject) => {
            jwt.login(payload.email, payload.password)
                .then(response => {

                    // If there's user data in response
                    if(response.data) {

                        // Set accessToken
                        localStorage.setItem("accessToken", response.headers.authorization);
                        //window.app.$cookies.set("content_token", response.headers.authorization, null, null, ".3proj.com");

                        // Update user details
                        commit('UPDATE_USER_INFO', response.data.data);

                        // Store users to users list
                        commit('users/SET_USERS', response.data.data, {root: true});

                        // Set bearer token in axios
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.headers.authorization;

                        // Set user
                        store.dispatch('auth/setUser', response.data.data);

                        // Resolve
                        resolve(response.data.data)
                    }else {
                        reject({message: "Wrong Email or Password"})
                    }

                })
                .catch(error => { reject(error) })
        })
    },

    logout({commit}) {
        return new Promise((resolve) => {
            // logout app
            jwt.logout();

            // Set accessToken
            localStorage.removeItem("accessToken");
            window.app.$cookies.remove("content_token");

            // Update user details
            commit('auth/UPDATE_USER_INFO', {id: 0, name:'', mail:''}, {root: true});

            // Reset tasks
            commit('tree/RESET_TASKS', {}, {root: true});

            resolve();
        });
    },

    /**
     * Register new user
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    register({ commit }, payload) {

        const { first_name, second_name, email, password, password_again } = payload;

        return new Promise((resolve,reject) => {

            // Check confirm password
            if(password !== password_again) {
                reject({message: "Password doesn't match. Please try again."})
            }

            jwt.registerUser(first_name, second_name, email, password)
                .then(response => {
                    // Redirect User
                    router.push(router.currentRoute.query.to || '/')

                    // Update data in localStorage
                    localStorage.setItem("accessToken", response.data.accessToken);
                    commit('UPDATE_USER_INFO', response.data.data, {root: true});

                    resolve(response)
                })
                .catch(error => { reject(error) })
        })
    },

    refresh() {

        return new Promise((resolve) => {
            jwt.refreshToken().then(response => { resolve(response) })
        })
    },

    /**
     * get users positions
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadUserPositions({commit}) {
        return api.call(commit, 'get', '/api/positions/list', false, 'SET_USERS_POSITIONS');
    },


    /**
     * get users actions
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadUsersActions({commit}) {
        return api.call(commit, 'get', '/api/users/get-actions', false);
    },

    /*
     * Action feedbacl
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setActionFeedback({commit}, {action, value}) {
        return api.call(commit, 'get', `/api/users/set-action/${action}/${value}`, false);
    },


    // set user data
    setUser({commit}, data) {

        // Store users to users list
        commit('users/SET_USERS', data, {root: true});

        // Set info
        commit('UPDATE_USER_INFO', data);

        // Update laravel echo auth header
        window.Echo.connector.pusher.config.auth.headers['Authorization'] = axios.defaults.headers.common['Authorization'];

        // Set auth as cookie
        window.app.$cookies.set("content_token", axios.defaults.headers.common['Authorization'].replace("Bearer ", ""), null, null, window.location.hostname !== 'localhost' ? (".3proj.com") : null);

        // Start syncronizer
        synchronizer.init(data);

    },



}
